export const REMOVE_ENGAGEMENTS_ATTACHMENT_REQUEST = 'REMOVE_ENGAGEMENTS_ATTACHMENT_REQUEST';
export const REMOVE_ENGAGEMENTS_ATTACHMENT_SUCCESS = 'REMOVE_ENGAGEMENTS_ATTACHMENT_SUCCESS';
export const REMOVE_ENGAGEMENTS_ATTACHMENT_FAILURE = 'REMOVE_ENGAGEMENTS_ATTACHMENT_FAILURE';
